import React from 'react'

const ExpertiseView = () => {
    return (
        <section id="who-needs-sofia" className="py-20 bg-white">
            <div className="container mx-auto px-4">
                <div className="flex flex-wrap justify-center text-center mb-24">
                    <div className="w-full lg:w-6/12 px-4">
                        <h2 className="text-4xl font-semibold">Who Needs Sofia's Expertise?</h2>
                        <p className="text-lg leading-relaxed mt-4 text-blueGray-500">
                            Sofia's expert editing and proofreading services are invaluable for:
                        </p>
                    </div>
                </div>
                {/* <div className="flex flex-wrap"> */}
                <div className="flex flex-wrap gap-6 -mx-2">

                    {/* <div className="w-full md:w-3/12 px-4"> */}
                    <div className="w-full md:w-4/12 px-2">

                        <div className="text-center p-8 bg-gray-50 rounded-lg">
                            <div className="text-blueGray-500 p-3 text-center inline-flex items-center justify-center ">
                            <img src={require("assets/icon/exp/search.png")}

alt="Proofreading & Editing" className="w-16 h-16" />                            </div>
                            <h6 className="text-xl font-semibold">Academics and Researchers</h6>
                            <p className="mt-2 text-blueGray-500">
                                Enhance the clarity, accuracy, and impact of your scholarly work.
                            </p>
                        </div>
                    </div>
                    <div className="w-full md:w-4/12 px-2">
                        <div className="text-center p-8 bg-gray-50 rounded-lg">
                            <div className="text-blueGray-500 p-3 text-center inline-flex items-center justify-center ">
                            //                         <img src={require("assets/icon/exp/authorize.png")}

alt="Proofreading & Editing" className="w-16 h-16" />                            </div>
                            <h6 className="text-xl font-semibold">Authors and Writers</h6>
                            <p className="mt-2 text-blueGray-500">
                                Polish your manuscript to perfection, preparing it for submission or publication.
                            </p>
                        </div>
                    </div>
                    <div className="w-full md:w-4/12 px-2">
                        <div className="text-center p-8 bg-gray-50 rounded-lg">
                            <div className="text-blueGray-500 p-3 text-center inline-flex items-center justify-center ">
                            //                         <img src={require("assets/icon/exp/graduated.png")}

alt="Proofreading & Editing" className="w-16 h-16" />                            </div>
                            <h6 className="text-xl font-semibold">Students</h6>
                            <p className="mt-2 text-blueGray-500">
                                Improve your academic writing and achieve better grades.
                            </p>
                        </div>
                    </div>
                    <div className="w-full md:w-4/12 px-2">
                        <div className="text-center p-8 bg-gray-50 rounded-lg">
                            <div className="text-blueGray-500 p-3 text-center inline-flex items-center justify-center  ">
                            //                         <img src={require("assets/icon/exp/professional.png")}

alt="Proofreading & Editing" className="w-16 h-16" />                            </div>
                            <h6 className="text-xl font-semibold">Businesses and Professionals</h6>
                            <p className="mt-2 text-blueGray-500">
                                Communicate effectively and professionally in the workplace.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>)
}

export default ExpertiseView

// import React from 'react'

// const ExpertiseView = () => {
//     return (
// <section id="who-needs-sofia" className="py-20 bg-white">
//     <div className="container mx-auto px-4">
//         <div className="flex flex-wrap justify-center text-center mb-24">
//             <div className="w-full lg:w-6/12 px-4">
//                 <h2 className="text-4xl font-semibold">Who Needs Sofia's Expertise?</h2>
//                 <p className="text-lg leading-relaxed mt-4 text-blueGray-500">
//                     Sofia's expert editing and proofreading services are invaluable for:
//                 </p>
//             </div>
//         </div>
//         <div className="flex overflow-x-auto gap-6 -mx-2">
//             <div className="flex-none w-72 px-2">
//                 <div className="text-center p-8 bg-gray-50 rounded-lg">
//                     <div className="text-blueGray-500 p-3 text-center inline-flex items-center justify-center  ">
//                         {/* <i className="fas fa-graduation-cap text-xl"></i> */}
//                         <img src={require("assets/icon/exp/search.png")}

// alt="Proofreading & Editing" className="w-16 h-16" />
//                     </div>
//                     <h6 className="text-xl font-semibold">Academics and Researchers</h6>
//                     <p className="mt-2 text-blueGray-500">
//                         Enhance the clarity, accuracy, and impact of your scholarly work.
//                     </p>
//                 </div>
//             </div>
//             <div className="flex-none w-72 px-2">
//                 <div className="text-center p-8 bg-gray-50 rounded-lg">
//                     <div className="text-blueGray-500 p-3 text-center inline-flex items-center justify-center ">
//                         {/* <i className="fas fa-pen-fancy text-xl"></i> */}
//                         <img src={require("assets/icon/exp/authorize.png")}

// alt="Proofreading & Editing" className="w-16 h-16" />
//                     </div>
//                     <h6 className="text-xl font-semibold">Authors and Writers</h6>
//                     <p className="mt-2 text-blueGray-500">
//                         Polish your manuscript to perfection, preparing it for submission or publication.
//                     </p>
//                 </div>
//             </div>
//             <div className="flex-none w-72 px-2">
//                 <div className="text-center p-8 bg-gray-50 rounded-lg">
//                     <div className="text-blueGray-500 p-3 text-center inline-flex items-center justify-center  ">
//                         {/* <i className="fas fa-user-graduate text-xl"></i> */}
//                         <img src={require("assets/icon/exp/graduated.png")}

// alt="Proofreading & Editing" className="w-16 h-16" />
//                     </div>
//                     <h6 className="text-xl font-semibold">Students</h6>
//                     <p className="mt-2 text-blueGray-500">
//                         Improve your academic writing and achieve better grades.
//                     </p>
//                 </div>
//             </div>
//             <div className="flex-none w-72 px-2">
//                 <div className="text-center p-8 bg-gray-50 rounded-lg">
//                     <div className="text-blueGray-500 p-3 text-center inline-flex items-center justify-center  ">
//                         {/* <i className="fas fa-briefcase text-xl"></i> */}
//                         <img src={require("assets/icon/exp/professional.png")}

// alt="Proofreading & Editing" className="w-16 h-16" />
//                     </div>
//                     <h6 className="text-xl font-semibold">Businesses and Professionals</h6>
//                     <p className="mt-2 text-blueGray-500">
//                         Communicate effectively and professionally in the workplace.
//                     </p>
//                 </div>
//             </div>
//         </div>
//     </div>
// </section>
//         )
// }

// export default ExpertiseView